import React from "react";

import styles from "./ChooseDateHeader.style";
import {Div, Text} from "@vkontakte/vkui";
import {connect} from "react-redux";

const ChooseDateHeader = ({
                              selectedMedicalOrganisation,
                              selectedDoctorName,
                              selectedDoctorSpeciality
                          }) => {


    const upperCaseFirst = (string) => {
        if (string) {
            return [
                ...string[0].toUpperCase(),
                ...string.slice(1)
            ].join("");
        } else {
            return ""
        }

    }

    const getShortAddress = (address) => {
        const addressWithoutIndex = address.slice(8);
        const commaIndex = addressWithoutIndex.indexOf(",");
        return addressWithoutIndex.split("").slice(commaIndex + 1).join("");
    }

    const getDoctorName = (selectedDoctorName) => {
        if (selectedDoctorName) {
            return selectedDoctorName.Resource_Name;
        } else {
            return ""
        }
    }

    const getDoctorSpeciality = (selectedDoctorSpeciality) => {
        if (selectedDoctorSpeciality) {
            return selectedDoctorSpeciality.Service_Name;
        } else {
            return ''
        }
    }

    return (
        <>
            <Div style={styles.wrapper}>
                <Text style={styles.secondHeader}
                      weight={"regular"}>{selectedMedicalOrganisation?.title || selectedMedicalOrganisation?.Organization_Name}</Text>
                <Text style={styles.address}
                      weight={"regular"}>{getShortAddress(selectedMedicalOrganisation?.Address_MO)}</Text>
                <Text style={{
                    ...styles.secondHeader,
                    ...styles.secondLine
                }} weight={"regular"}>{upperCaseFirst(getDoctorSpeciality(selectedDoctorSpeciality))}</Text>
                <Text style={styles.name} weight={"regular"}>{getDoctorName(selectedDoctorName)}</Text>

            </Div>
            <Text style={styles.visitDate} weight={"regular"}>Дата посещения</Text>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        selectedMedicalOrganisation: state.regionAndMedicalOrganisation.selectedMedicalOrganisation ? state.regionAndMedicalOrganisation.selectedMedicalOrganisation : state.moscowScenario.medicalOrganisation,
        selectedDoctorName: state.doctors.selectedDoctorName || state.moscowScenario.selectedDoctorName,
        selectedDoctorSpeciality: state.doctors.selectedDoctorSpeciality || state.moscowScenario.selectedSpeciality
    }
}
export default connect(mapStateToProps, null)(ChooseDateHeader);
